import React from 'react';
import Modal from './Modal';

interface ContentViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  content: string;
}

const ContentViewModal: React.FC<ContentViewModalProps> = ({
  isOpen,
  onClose,
  title,
  content,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`查看内容 - ${title}`}>
      <div className="space-y-4">
        <div className="bg-gray-50 dark:bg-gray-100 rounded-lg p-4 border border-gray-200 dark:border-gray-300">
          <div className="whitespace-pre-wrap break-words leading-relaxed text-gray-900 dark:text-gray-900 max-h-96 overflow-y-auto">
            {content}
          </div>
        </div>
        
        <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-600">
          <span>字符数：{content.length}</span>
          <span>行数：{content.split('\n').length}</span>
        </div>
        
        <div className="flex justify-end pt-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-100 dark:bg-gray-200 text-gray-800 dark:text-gray-900 rounded-lg hover:bg-gray-200 dark:hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 transition-colors duration-200"
          >
            关闭
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ContentViewModal;
